import {takeLatest, takeLeading} from "redux-saga/effects";

import * as UserActions from "@atg-global-shared/user/userActionTypes";
import {USER_ENTERED_TILLSAMMANS} from "@atg-tillsammans/app-data-access/redux";
import {TeamMemberActions} from "@atg-tillsammans/team-member-data-access";

import * as PushGenerators from "./tillsammansPushGenerators";

import type {Dispatch} from "redux";
import type {SagaIterator} from "redux-saga";

export default function* tillsammansPushSaga(dispatch: Dispatch<any>): SagaIterator {
    /**
     * TODO: Listen to action that triggers when entering tillsammans, NEW action needed suggested name
     * EVENT_MEMBER_ENTERED_TILLSAMMANS as its named on the backend.
     */
    yield takeLeading(
        [UserActions.LOGIN_FINISHED, UserActions.RECEIVE_USER, USER_ENTERED_TILLSAMMANS],
        PushGenerators.subscribeUserToPush,
        dispatch,
    );
    yield takeLatest(
        TeamMemberActions.setMemberTeams.type,
        PushGenerators.subscribeOnBehalfOf,
    );
}
